// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"a24fe83e","197":"f6b60a72","720":"f6b60a72"}[chunkId] + ".chunk.css";
};